"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bit_javascript_default_generator_canonize_1 = require("@bit/bit.javascript.default-generator.canonize");

var bit_javascript_raw_code_generator_1 = require("@bit/bit.javascript.raw.code-generator");

var codeGenerator = new bit_javascript_raw_code_generator_1.CodeGenerator();
exports.mainFile = 'index.js';

function makeTemplate(_a) {
  var _b;

  var npmId = _a.npmId;
  var code = generateReactDefaultCode(npmId);
  return {
    files: (_b = {}, _b[exports.mainFile] = code, _b),
    mainFile: exports.mainFile
  };
}

exports.makeTemplate = makeTemplate;

function generateReactDefaultCode(npmId) {
  var defaultName = bit_javascript_default_generator_canonize_1.toCanonicalClassName(npmId);
  var moduleId = bit_javascript_default_generator_canonize_1.canonizeNpmId(npmId);
  return codeGenerator.generateModule({
    imports: [{
      defaultName: 'React',
      moduleId: 'react'
    }, {
      defaultName: defaultName,
      moduleId: moduleId
    }],
    defaultExport: "<" + defaultName + "/>"
  });
}